import { useEffect, useRef } from 'react';

export const useSafeEffect = (
  effect: () => void | Promise<void> | (() => void),
  deps: any[] = []
) => {
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current === false) {
      const cleanup = effect();

      return () => {
        if (cleanup instanceof Function) {
          cleanup();
        }
        effectRan.current = true;
      };
    }
  }, deps);
};
